import { ITermsResponse } from "@literax/models/terms.model";

export interface IFreeTermsState {
  terms_of_service: ITermsResponse
}
  
export const initialFreeTermsState: IFreeTermsState = {
  terms_of_service: null
};
